import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { StateSnapshot } from 'react-virtuoso'

export type DialogsSliceState = {
  // Used for remembering scroll position of virtualized dialogs list
  serializedVirtuosoSnapshot: string | undefined
}

export const initialState: DialogsSliceState = {
  serializedVirtuosoSnapshot: undefined
}

export const slice = createSlice({
  name: 'dialogs',
  initialState,
  reducers: {
    storeVirtuosoSnapshot: (state, action: PayloadAction<StateSnapshot>) => {
      state.serializedVirtuosoSnapshot = JSON.stringify(action.payload)
    }
  }
})

export const actions = slice.actions
export const reducer = slice.reducer
